<div class="w-full">
  <p class="text-xs">
    {{ "lbl.security_rating" | translate }}
    <span class="text-xs font-semibold" *ngIf="msg">{{ msg | translate }}</span>
  </p>
  <ul class="mt-4 h-1.5 w-full rounded-[80px] bg-neutral-100">
    <li
      class="point h-1.5 rounded-[80px]"
      [style.width.%]="width"
      [style.backgroundColor]="passwordColor"></li>
  </ul>
  <div class="mt-3">
    <p
      [class]="isPassedMinlenght ? 'text-green-500' : 'text-neutral-500'"
      class="m-0 block w-full text-left text-xs">
      1. <span translate>lbl.min8Chars</span>
    </p>
    <p
      [class]="
        isPassedUppercase || isPassedLowercase || isPassedNumbericDigits
          ? 'text-green-500'
          : 'text-neutral-500'
      "
      class="m-0 block w-full text-left text-xs">
      2. <span translate>lbl.mustContain</span>
    </p>
    <p
      [class]="isPassedUppercase ? 'text-green-500' : 'text-neutral-500'"
      class="m-0 ml-4 mt-1 block w-full text-left text-xs">
      a. <span translate>lbl.upperAlphabet</span>
    </p>
    <p
      [class]="isPassedLowercase ? 'text-green-500' : 'text-neutral-500'"
      class="m-0 ml-4 mt-1 block w-full text-left text-xs">
      b. <span translate>lbl.lowerAlphabet</span>
    </p>
    <p
      [class]="isPassedNumbericDigits ? 'text-green-500' : 'text-neutral-500'"
      class="m-0 ml-4 mt-1 block w-full text-left text-xs">
      c. <span translate>lbl.numbericDigits</span>
    </p>
  </div>
</div>
